import { ControlledInput, ControlledRadioGroup } from "@dune/ui";
import { useFormContext, useWatch } from "react-hook-form";
import { ConstructionSiteDetailsFormData } from "./useConstructionSiteDetailsForm";
import { CreateConstructionSiteClientFormData } from "./useCreateConstructionSiteForm";
import { ControlledPriceInput } from "../../../components/inputs/ControlledPriceInput";

const IsSyndicContainer = ({
	formKey,
}: { formKey: "clientSociety" | "syndicSociety" }) => {
	const { control, formState } = useFormContext<
		CreateConstructionSiteClientFormData | ConstructionSiteDetailsFormData
	>();
	const { errors } = formState;
	const hasBrokerageFeesValue = useWatch({
		control,
		name: `${formKey}.hasBrokerageFees`,
	});

	const hasUserAccessValue = useWatch({
		control,
		name: `${formKey}.hasUserAccess`,
	});
	return (
		<div className="flex flex-col gap-4">
			<div className="flex flex-col border-solid border-1 border-gray-200 rounded-lg p-4 gap-4">
				<ControlledRadioGroup
					control={control}
					name={`${formKey}.hasBrokerageFees`}
					label="Souhaitez-vous ajouter des Frais Annexes de courtage à chaque projet de
				ce syndic ?"
					items={[
						{ id: "has-brokerage-fees", value: "true", label: "Oui" },
						{ id: "no-brokerage-fees", value: "false", label: "Non" },
					]}
				/>
				{hasBrokerageFeesValue === "true" && (
					<ControlledPriceInput
						control={control}
						name={`${formKey}.brokerageFees`}
						label="Montant des frais annexes"
						iconOrText="€"
					/>
				)}
			</div>
			<div className="flex flex-col border-solid border-1 border-gray-200 rounded-lg p-4 gap-4">
				<ControlledRadioGroup
					control={control}
					name={`${formKey}.hasUserAccess`}
					label="Souhaitez-vous que ce syndic ait un accès à la plateforme lui permettant
					de soumettre ses chantiers ?"
					items={[
						{ id: "has-user-access", value: "true", label: "Oui" },
						{ id: "no-user-access", value: "false", label: "Non" },
					]}
				/>
				{hasUserAccessValue === "true" && (
					<div className="flex flex-col items-center gap-4">
						<div className="flex flex-row gap-4 w-full">
							<ControlledInput
								control={control}
								name={`${formKey}.userAccess.lastname`}
								label="Nom"
								error={(
									errors[formKey as keyof typeof errors]?.userAccess as {
										lastname: { message: string };
									}
								)?.lastname?.message?.toString()}
							/>
							<ControlledInput
								control={control}
								name={`${formKey}.userAccess.firstname`}
								label="Prénom"
								error={(
									errors[formKey as keyof typeof errors]?.userAccess as {
										firstname: { message: string };
									}
								)?.firstname?.message?.toString()}
							/>
						</div>
						<ControlledInput
							control={control}
							name={`${formKey}.userAccess.email`}
							label="Email"
							error={(
								errors[formKey as keyof typeof errors]?.userAccess as {
									email: { message: string };
								}
							)?.email?.message?.toString()}
						/>
					</div>
				)}
			</div>
		</div>
	);
};

export default IsSyndicContainer;
